import { getCookie } from "@insite/client-framework/Common/Cookies";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/UpdateSearchFields";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { GetCustomerPartsApiParameter } from "@midland-industries/Services/CustomerPartService";
import {
    CustomerPartsDataViewContext,
    getCustomerPartsDataView,
} from "@midland-industries/Store/Data/CustomerParts/CustomerPartsSelectors";
import loadCustomerParts from "@midland-industries/Store/Pages/CustomerPartNumber/Handlers/LoadCustomerParts";
import qs from "qs";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: any) => ({
    getCustomerPartsParameter: state.customerPartPagination.getCustomerPartsParameter,
    customerPartsDataView: getCustomerPartsDataView(state, state.customerPartPagination.getCustomerPartsParameter),
    location: getLocation(state),
});

const mapDispatchToProps = {
    loadCustomerParts,
    updateSearchFields,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const CustomerPartsHistoryPage = ({
    loadCustomerParts,
    id,
    customerPartsDataView,
    history,
    location,
    getCustomerPartsParameter,
}: Props) => {
    let firstLoad = false;
    useEffect(() => {
        firstLoad = true;
        const pageSizeCookie = getCookie("CustomerPartsHistory-PageSize");
        const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
        if (location.search && location.search.indexOf("SwitchingLanguage") === 0) {
            const getCustomerPartsApiParameter = parseQueryString<GetCustomerPartsApiParameter>(location.search);
            if (pageSize) {
                getCustomerPartsApiParameter.pageSize = pageSize;
            }
            updateSearchFields({ ...getCustomerPartsApiParameter, type: "Replace" });
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            const queryString = qs.stringify(getCustomerPartsParameter);
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [getCustomerPartsParameter]);

    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!customerPartsDataView.value && !customerPartsDataView.isLoading) {
            loadCustomerParts(getCustomerPartsParameter);
        }
    });

    return (
        <Page>
            <CustomerPartsDataViewContext.Provider value={customerPartsDataView}>
                <Zone contentId={id} zoneName="Content" />
            </CustomerPartsDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(CustomerPartsHistoryPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

export const CustomerPartsHistoryPageContext = "CustomerPartsHistoryPage";
